import React from 'react'
import FormCreatePartnerNotValidate from '../../../components/FormCreatePartnerNotValidate'

const CreateNotValidate = () => <FormCreatePartnerNotValidate />

export default CreateNotValidate
